import { render, staticRenderFns } from "./CustomerHome.vue?vue&type=template&id=9bc5d574&scoped=true&"
import script from "./CustomerHome.vue?vue&type=script&lang=js&"
export * from "./CustomerHome.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHome.vue?vue&type=style&index=0&id=9bc5d574&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc5d574",
  null
  
)

export default component.exports